import { render, staticRenderFns } from "./PointScoreLists.vue?vue&type=template&id=1b51338e&"
import script from "./PointScoreLists.vue?vue&type=script&lang=js&"
export * from "./PointScoreLists.vue?vue&type=script&lang=js&"
import style0 from "./PointScoreLists.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports